import React from 'react';
import { Header } from 'layout';
import { UserTransactionsTable } from 'modules';
import { useGetIraUser } from 'hooks/api/iraUser';
import { useGetProfileTransactions } from 'hooks/api/portfolio';
import { USER_TYPE } from 'constants/userTypes';
import { USER_STATUS } from 'constants/status';
import { EntityStatus } from 'components/Label';
import StatusUserButton from 'components/StatusUserButton';
import EmptyPage from 'components/EmptyPage';
import GenerateAccountStatementButton from 'components/GenerateAccountStatementButton';
import IraUserNavTabs from '../components/IraUserNavTabs';
import IraUserBalance from '../components/IraUserBalance';
import IraUserActiveLimitOrders from '../components/IraUserActiveLimitOrders';

import styles from './IraUserTransactions.module.css';

const IraUserTransactions: React.FC = () => {
  const { data: iraUser } = useGetIraUser();
  const {
    data: transactionsData,
    isLoading: portfolioTransactionsLoading,
    isError,
    refetch,
    isRefetching,
    isSuccess,
  } = useGetProfileTransactions();

  return (
    <>
      <Header
        title={
          iraUser
            ? `${iraUser?.firstName} ${iraUser?.middleName ?? ''} ${iraUser?.lastName}`
            : ''
        }
        complexComponent={true}
        label={{
          status: iraUser?.profileStatus ?? '',
          entityStatus: EntityStatus.User,
          isAccountClosed: iraUser?.accountClosed,
        }}
        showArrow={true}
      >
        {iraUser && <StatusUserButton user={iraUser} userType={USER_TYPE.iraUser} />}
        {iraUser?.profileStatus === USER_STATUS.active && (
          <GenerateAccountStatementButton user={iraUser} />
        )}
      </Header>

      <IraUserNavTabs />

      {iraUser?.profileStatus === USER_STATUS.active ? (
        <>
          <div className={styles.metricsWrapper}>
            <IraUserBalance />
            <IraUserActiveLimitOrders enableToFetch={isSuccess} />
          </div>
          <UserTransactionsTable
            transactionsData={transactionsData}
            portfolioTransactionsLoading={portfolioTransactionsLoading}
            isError={isError}
            refetch={refetch}
            isRefetching={isRefetching}
          />
        </>
      ) : (
        <EmptyPage />
      )}
    </>
  );
};

export default IraUserTransactions;
